import React, { useState } from 'react'
import { Modal, Button, TextField } from '@ui'
import { revokeOrg } from '../api.js'

export function RevokeOrgModal({ org, onClose, onRevoked }) {
  const [confirm, setConfirm] = useState('')
  const [err, setErr] = useState(null)
  const [busy, setBusy] = useState(false)
  const match = confirm === org.name

  async function submit(e) {
    e.preventDefault()
    if (!match) return
    setBusy(true); setErr(null)
    try {
      await revokeOrg(org.orgId, { confirmName: confirm })
      onRevoked()
    } catch (e) {
      setErr(e.message || 'Failed to revoke org.')
    } finally { setBusy(false) }
  }

  return (
    <Modal open onClose={onClose} title="Revoke org">
      <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        <p>
          <strong>⚠ Permanently revoke {org.name}?</strong>
        </p>
        <p style={{ opacity: 0.8 }}>
          All admins will be disabled in Cognito immediately. Data is soft-deleted
          and retained for 90 days. <strong>This cannot be undone.</strong>
        </p>
        <label>Type the org name to confirm
          <TextField value={confirm} onChange={(e) => setConfirm(e.target.value)} autoFocus />
        </label>
        {err && <div style={{ color: 'var(--danger-text)' }}>{err}</div>}
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <Button type="button" variant="secondary" onClick={onClose}>Cancel</Button>
          <Button type="submit" variant="danger" disabled={!match || busy}>
            {busy ? 'Revoking…' : 'Revoke permanently'}
          </Button>
        </div>
      </form>
    </Modal>
  )
}
